import { render } from "./ColoringGame.vue?vue&type=template&id=d7905960&scoped=true"
import script from "./ColoringGame.vue?vue&type=script&lang=js"
export * from "./ColoringGame.vue?vue&type=script&lang=js"

import "./ColoringGame.vue?vue&type=style&index=0&id=d7905960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7905960"]])

export default __exports__